import React from "react";
import { useTranslation } from "react-i18next";
import { Body1, Caption1 } from "@activecollab/components";
import PropTypes from "prop-types";
import UserLink from "~/components/UserLink/UserLink";
import WorkAvailability from "~/components/Workload/WorkloadUser/WorkAvailability";

export const UsersColumn = ({ usersData, context, isFetching }) => {
  const { t } = useTranslation();

  return (
    <div className="tw-w-52 md:tw-w-96 tw-shrink-0">
      <Caption1
        className="tw-h-10 tw-px-5 tw-flex tw-items-center tw-border-b tw-border-border-primary tw-border-solid tw-border-0"
        weight="bold"
        color="secondary"
      >
        {t("Name")}
      </Caption1>

      <Body1
        weight="bold"
        className="tw-h-10 tw-px-5 tw-flex tw-items-center tw-border-b tw-border-r tw-border-border-primary tw-border-solid tw-border-0 tw-bg-primary-200"
      >
        {t("Total:")}
      </Body1>

      {usersData.map((user) => (
        <div
          key={user.user_id}
          className="odd:tw-bg-theme-200 tw-h-10 tw-px-5 tw-flex tw-items-center tw-justify-between tw-border-b tw-border-r tw-border-border-primary tw-border-solid tw-border-0"
        >
          <UserLink
            id={user.user_id}
            context={context}
          />
          {!isFetching ? (
            <WorkAvailability
              id={user.user_id}
              className="sm:tw-flex tw-hidden"
            />
          ) : null}
        </div>
      ))}
    </div>
  );
};

UsersColumn.propTypes = {
  context: PropTypes.string.isRequired,
  isFetching: PropTypes.bool,
  usersData: PropTypes.array,
};
